<template>
  <div class="header-seven">
    <img
      :src="
        ` ${
          restaurant.logo
            ? 'https://space.monresto.menu/logos/' + restaurant.logo
            : 'https://space.monresto.menu/logos/logo.png'
        } `
      "
      alt=""
      class="logo-seven"
    />
    <h2
      class="menuName-seven"
      v-text="newItem[currentLang] ? newItem[currentLang].name : ''"
    >
      {{ name }}
    </h2>
    <p class="description-seven">
      {{ restaurant.observation ? restaurant.observation : "" }}
    </p>
  </div>
</template>

<script>
export default {
  props: [
    "restaurant",
    "smaler",
    "changeName",
    "currentLang",
    "newItem",
    "currentLang"
  ],

  data() {
    return {
      // apiPath1: apiPath1,
      name: "name of the menu"
    };
  },
  methods: {},
  watch: {
    name(newVal) {
      this.changeName(newVal);
    }
  }
};
</script>
<style>
@import url('../styles/sevenTheme/header.css');
</style>
